import './MediaBlock/register'
import './MediaCategory/register'
import './MediaList/register'
import './MediaProductStepByStep/register'
import './MediaWithBackground/register'
import './MediaProductGuides/register'
import './MediaCardList/register'
import './MediaTestimonial/register'
